import classnames from 'classnames'
import { useTranslation } from 'next-i18next'

import { PAGE_PATH } from '@src/quince-site-common/src/constants/pageData'
import { ISubscribedPlan } from '@src/quince-site-common/src/domains/Subscription'

import Image from '../image/Image'
import Link from '../link'
import { ICON_CONSTANTS, ICON_CONSTANTS_MAP } from '../productForm/icon-constants'

import styles from './productSubscriptionDeliveryMessage.module.scss'

const ProductSubscriptionDeliveryMessage = ({
  subscribedPlan,
  showNewPdpDesignV2,
}: {
  subscribedPlan: ISubscribedPlan
  showNewPdpDesignV2: boolean
}) => {
  const { t } = useTranslation('common')

  const formattedNextDeliveryDate = new Date(subscribedPlan.nextDeliveryDate)
    // eslint-disable-next-line i18next/no-literal-string
    .toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
    })

  if (!subscribedPlan?.nextDeliveryDate) return null

  return (
    <div
      className={classnames(styles.subscriptionDeliveryMessage, {
        [styles.subscriptionDeliveryMessage_newDesignV2 ?? '']: showNewPdpDesignV2,
      })}
    >
      <div className={styles.contentWrapper}>
        <div className={styles.iconWrapper}>
          <Image
            url={ICON_CONSTANTS_MAP[ICON_CONSTANTS.RECURRING_ICON_BLACK]}
            title={ICON_CONSTANTS.RECURRING_ICON_BLACK}
            alt=""
            className={styles.iconImage}
          />
        </div>
        <p className={styles.text}>{`${t('subscribed')}: ${t('next_delivery_by')} ${formattedNextDeliveryDate}`}</p>
      </div>
      <Link href={`/${PAGE_PATH.MY_SUBSCRIPTIONS}`} className={classnames(styles.manageSubscriptionLink)}>
        {t('manage')}
      </Link>
    </div>
  )
}

export default ProductSubscriptionDeliveryMessage
